import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';
import React from 'react';
import { DetailsOptions } from './Components/SlideoutInbox';
import { Inbox } from './index';

export default (): React.ReactElement => {
    const detailsOptions: DetailsOptions = {
        menuItems: (props) => [
            {
                label: 'Notification content',
                onClick: () => {
                    showAlertDialog({
                        title: 'Notification content',
                        content: <pre>{JSON.stringify(props.notification, null, 2)}</pre>,
                    });
                },
            },
        ],
    };

    return (
        <Inbox
            options={{
                details: detailsOptions,
            }}
        />
    );
};


export const src = "import { showAlertDialog } from '@juvare/common-web-ui/DialogHelper';\nimport React from 'react';\nimport { DetailsOptions } from './Components/SlideoutInbox';\nimport { Inbox } from './index';\n\nexport default (): React.ReactElement => {\n    const detailsOptions: DetailsOptions = {\n        menuItems: (props) => [\n            {\n                label: 'Notification content',\n                onClick: () => {\n                    showAlertDialog({\n                        title: 'Notification content',\n                        content: <pre>{JSON.stringify(props.notification, null, 2)}</pre>,\n                    });\n                },\n            },\n        ],\n    };\n\n    return (\n        <Inbox\n            options={{\n                details: detailsOptions,\n            }}\n        />\n    );\n};\n";